// extracted by mini-css-extract-plugin
module.exports = {"title":"SensorResource_title__UsEi0"};